//Delete everything button
//Delete everything button
//Delete everything button
//Delete everything button
//Delete everything button
var exports = (module.exports = {});
var deleteEverythingButton = document.createElement("button");
deleteEverythingButton.className = "mapbox-gl-draw_ctrl-draw-btn";
deleteEverythingButton.innerHTML = `
<svg
role="img"
viewBox="0 0 640 512"
class="svg-inline--fa"
>
<path
d="M120 376c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 
24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 
10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm238.6 49.4c-14.5-14.5-22.6-34.1-22.6-54.6V269.2c0-20.5 8.1-40.1 
22.6-54.6l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0l-36.7 36.7c-26.5 26.5-41.4 62.4-41.4
99.9V288h-64v-50.9c0-8.7-1.8-17.2-5.2-25.2L364.5 29.1C356.9 11.4 339.6 0 320.3 0H176c-26.5 0-48 21.5-48 48v112h-16c-26.5 
0-48 21.5-48 48v91.2C26.3 317.2 0 355.4 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 
0-17.3-4.2-33.4-11.2-48H512v18.7c0 37.5 14.9 73.4 41.4 99.9l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0l22.6-22.6c6.2-6.2 
6.2-16.4 0-22.6l-36.7-36.7zM192 64h117.8l68.6 160H256l-64-64V64zm176 384H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h256c26.5 0
48 21.5 48 48s-21.5 48-48 48z"
/>
</svg>
`;
deleteEverythingButton.style = "color: black;font-size: 15px;margin-bottom: 1px;margin-top: 2px;";
deleteEverythingButton.title = "Clean everything";
deleteEverythingButton.onclick = function() {
	var event = new CustomEvent("delete_everything_button.clicked");
	document.dispatchEvent(event);
	return true;
};
exports.deleteEverythingButton = deleteEverythingButton;

//Cut button
//Cut button
//Cut button
//Cut button
var cutButton = document.createElement("button");
cutButton.className = "mapbox-gl-draw_ctrl-draw-btn";
cutButton.innerHTML = `
<svg
role="img"
viewBox="0 0 640 512"
class="svg-inline--fa"
>
<path
d="M278.06 256L444.48 89.57c4.69-4.69 4.69-12.29 0-16.97-32.8-32.8-85.99-32.8-118.79 0L210.18 
188.12l-24.86-24.86c4.31-10.92 6.68-22.81 6.68-35.26 0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 
96 96 96c4.54 0 8.99-.32 13.36-.93L142.29 256l-32.93 32.93c-4.37-.61-8.83-.93-13.36-.93-53.02 0-96 
42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-12.45-2.37-24.34-6.68-35.26l24.86-24.86L325.69 
439.4c32.8 32.8 85.99 32.8 118.79 0 4.69-4.68 4.69-12.28 0-16.97L278.06 256zM96 160c-17.64 
0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 
32 14.36 32 32-14.36 32-32 32z"
/>
</svg>
`;
cutButton.style = "color: black;font-size: 15px;margin-bottom: 1px;padding-left: 6px;margin-top: 2px;";
cutButton.title = "Cut tool";
cutButton.onclick = function() {
	var event = new CustomEvent("map_cut_mode_button.clicked");
	document.dispatchEvent(event);
	return true;
};
exports.cutButton = cutButton;

//Base polygon tool
var basePolyButton = document.createElement("button");
basePolyButton.className = "mapbox-gl-draw_ctrl-draw-btn";
basePolyButton.innerHTML = `
<svg
role="img"
viewBox="0 0 448 512"
class="svg-inline--fa"
>
<path
d="M384 352c-.35 0-.67.1-1.02.1l-39.2-65.32c5.07-9.17 8.22-19.56 
8.22-30.78s-3.14-21.61-8.22-30.78l39.2-65.32c.35.01.67.1 1.02.1 35.35 0 64-28.65 64-64s-28.65-64-64-64c-23.63 
0-44.04 12.95-55.12 32H119.12C108.04 44.95 87.63 32 64 32 28.65 32 0 60.65 0 96c0 23.63 12.95 44.04 
32 55.12v209.75C12.95 371.96 0 392.37 0 416c0 35.35 28.65 64 64 64 23.63 0 44.04-12.95 55.12-32h209.75c11.09 
19.05 31.49 32 55.12 32 35.35 0 64-28.65 64-64 .01-35.35-28.64-64-63.99-64zm-288 8.88V151.12A63.825 
63.825 0 0 0 119.12 128h208.36l-38.46 64.1c-.35-.01-.67-.1-1.02-.1-35.35 0-64 28.65-64 64s28.65 64 
64 64c.35 0 .67-.1 1.02-.1l38.46 64.1H119.12A63.748 63.748 0 0 0 96 360.88zM272 256c0-8.82 7.18-16 16-16s16 
7.18 16 16-7.18 16-16 16-16-7.18-16-16zM400 96c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM64 
80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 416c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 
16-16 16-16-7.18-16-16zm336 16c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"
/>
</svg>
`;
basePolyButton.style = "color: black;font-size: 15px;margin-bottom: 1px;margin-top: 2px;";
basePolyButton.title = "Draw base polygon tool";
basePolyButton.onclick = function() {
	var event = new CustomEvent("base_polygon_draw_button.clicked");
	document.dispatchEvent(event);
	return true;
};
exports.basePolyButton = basePolyButton;

//Filler button. This button does nothing, just stands there likj
var fillerButton = document.createElement("div");
fillerButton.style = "height: 68px;background-color:#3490dc";
exports.fillerButton = fillerButton;
